export default {

  // 课程介绍列表
  getSubjectList(params, success) {
    Request.GET('/subject', params, response => success(response));
  },

  // 查询课程介绍详情
  getSubjectDetail(id, success) {
    Request.GET(`/subject/${id}`, null, response => success(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/subjectApi.js